import React from 'react'
import { Result, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { getClientEnv } from '../../../utils/common'
import styles from './index.module.scss'

const DS_ADMIN: any = {
  product: 'https://digitalserviceportal.xiaopeng.com/#/business-operate/serviceRecord',
  deploy: 'https://digitalserviceportal.deploy-test.xiaopeng.com/#/business-operate/serviceRecord',
  test: 'http://digitalserviceadmin.test.xiaopeng.local/#/business-operate/serviceRecord',
  dev: 'http://digitalserviceadmin.test.xiaopeng.local/#/business-operate/serviceRecord',
}

export default function Success() {
  const history = useHistory()

  const handleBack = () => {
    history.goBack()
  }

  const handleLinkToService = () => {
    const dsAdminUrl = DS_ADMIN[getClientEnv()]
    if (window.xdragon) {
      try {
        window.xdragon.callHandler('openDefaultBroswer', { url: dsAdminUrl })
      } catch (err) {
        window.location.href = dsAdminUrl
      }
      return
    }

    window.location.href = dsAdminUrl
  }

  const subTitle = () => {
    return (
      <p className={styles.subTitle}>
        如需更新，请前往
        <span className={styles.subTitleLink} onClick={handleLinkToService}>【数字化业务管理平台】</span>
      </p>
    )
  }

  return (
    <Result
      status="success"
      title="提交成功"
      subTitle={subTitle()}
      extra={<Button onClick={handleBack}>返回</Button>}
    />
  )
}
